import { useFetcher, useLocation } from "@remix-run/react";
import { ReactNode, useState } from "react";
import { INTENTS } from "./utils/intents";

export const NolaIsClosed = () => {
  const fetcherLogin = useFetcher<{ success: boolean; msg: string }>();
  const fetcherSignUp = useFetcher<{ success: boolean }>();
  const [showSignup, setShowSignup] = useState(false);
  const { pathname } = useLocation();
  console.log("NolaIsClosed render", { pathname, showSignup });
  return (
    <div className="flex h-[100vh] flex-col justify-end">
      <div className="lg:bg-halo-effect bg-halo-effect-mobile">
        <div className="mx-10 flex h-screen flex-col items-center justify-center">
          <div className="font-FKScreamer text-5xl uppercase">
            Beauty And Bullsh*t Don't Mix
          </div>
          {showSignup ? (
            <div className="flex w-full flex-col items-center">
              <fetcherSignUp.Form
                method="post"
                className="mt-10 flex min-w-[300px] max-w-[500px] flex-col items-start"
              >
                <input
                  type="hidden"
                  name="intent"
                  value={INTENTS.EMAIL_SIGNUP_FOR_SALE}
                />
                <Input placeholder="Nafn" name="name" />
                <Input placeholder="Netfang" name="email" />
                <div className="w-full pt-2">
                  <BigButton
                    state={
                      fetcherSignUp.state === "submitting"
                        ? "loading"
                        : "enabled"
                    }
                  >
                    {fetcherSignUp.data?.success
                      ? "Skráning tókst!"
                      : fetcherSignUp.state === "submitting"
                        ? "Skráning í gangi.."
                        : "Skrá mig"}
                  </BigButton>
                </div>
              </fetcherSignUp.Form>
              {fetcherSignUp.data?.success === true && (
                <div className="mt-4 text-center">
                  Takk fyrir að skrá þig! Kíktu á tölvupóstinn þinn 💅
                </div>
              )}
            </div>
          ) : (
            <div>
              <div className="my-10 max-w-[500px] text-center">
                Í dag er síðan okkar lokuð fyrir almenna umferð. Vinir okkar
                hafa fengið lykilorð sent í tölvupósti til að komast inn og nýta
                sér tilboðin okkar. Ef þú ert með lykilorðið, skráðu þig inn hér
                fyrir neðan 👇 Ef þú vilt fá aðgang, skráðu þig í Nola klúbbinn{" "}
                <div
                  className="inline cursor-pointer font-bold"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    console.log("showSignup click", showSignup);
                    setShowSignup(true);
                  }}
                >
                  hér
                </div>
              </div>
              <div className="flex w-full flex-col items-center justify-center">
                <fetcherLogin.Form method="post">
                  <Input type="password" name="password" />
                  <input type="hidden" name="intent" value="openNola" />
                  <input type="hidden" name="redirectTo" value={pathname} />
                  <BigButton
                    state={
                      fetcherLogin.state === "submitting"
                        ? "loading"
                        : "enabled"
                    }
                  >
                    Hleyptu mér inn
                  </BigButton>
                </fetcherLogin.Form>
              </div>
              <div className="mt-4">
                {fetcherLogin.data?.success === false &&
                  fetcherLogin.data.msg}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export type BigButtonState = "enabled" | "disabled" | "loading";

const BigButton = ({
  onClick,
  state = "enabled",
  children,
}: {
  onClick?: () => void;
  state?: BigButtonState;
  children: ReactNode;
}) => {
  return (
    <button
      onClick={() => {
        state === "enabled" && onClick && onClick();
      }}
      className={`relative flex h-12 w-full flex-row items-center justify-center  rounded border-1 bg-white text-xl font-bold text-black ${state !== "disabled"
        ? "cursor-pointer opacity-100 shadow-sm hover:opacity-80"
        : "opacity-10"
        } transition-colors duration-300`}
    >
      <div className="flex-1">{children}</div>
    </button>
  );
};

const Input = ({ name, error, placeholder, ...props }: InputProps) => {
  return (
    <div className="my-2 flex w-full flex-col items-start justify-start">
      <input
        className="h-10 w-full appearance-none rounded border px-2"
        placeholder={placeholder}
        name={name}
        {...props}
      ></input>
      {error && <div className="text-red-400">{error}</div>}
    </div>
  );
};

type InputProps = {
  name: string;
  error?: string;
  placeholder?: string;
} & Omit<
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >,
  "placeholder"
>;
